module.exports = __webpack_public_path__ + "img/discord.23bca370.png";